import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EstadisticasService {

  constructor(private http: HttpClient) { }

  getEstadisticasConsultas() {
      return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureforyear/?Tipo=Consultas");
  }
  
  getEstadisticasConsultorios() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureforyear/?Tipo=Consultorios");
}

}